import url from '../url'
import headers from '../headers'

export default {
	getAll (context, user_uid) {
		return context.$http.get(
			`${url}/users/${user_uid}/staff/`,
			headers.bearer()
		)
	},
	get (context, user_uid, staff_id) {
		return context.$http.get(
			`${url}/users/${user_uid}/staff/${staff_id}/`,
			headers.bearer()
		)
	},
	edit (context, user_uid, staff_id, model) {
		return context.$http.put(
			`${url}/users/${user_uid}/staff/${staff_id}/`,
			model,
			headers.bearer()
		)
	},
	permissions: {
		getAll (context, user_uid, staff_id) {
			return context.$http.get(
				`${url}/users/${user_uid}/staff/${staff_id}/permissions/`,
				headers.bearer()
			)
		}
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/staff.js